import { format, isToday as dateIsToday, isYesterday, differenceInCalendarDays } from 'date-fns'
import { ptBR } from 'date-fns/locale'

export const formatDate=(v:string)=>format(new Date(v),"dd MMM yyyy",{locale:ptBR})
export const formatTime=(v:string)=>format(new Date(v),'HH:mm')
export const isToday=(v:string)=>dateIsToday(new Date(v))
export const isOverdue=(v:string)=>new Date(v)<new Date()&&!dateIsToday(new Date(v))
export function formatRelativeDate(v:string){const d=new Date(v);if(dateIsToday(d))return `Hoje, ${formatTime(v)}`;if(isYesterday(d))return `Ontem, ${formatTime(v)}`;const n=differenceInCalendarDays(d,new Date());if(n===1)return 'Amanhã';if(n>1&&n<7)return `Em ${n} dias`;return format(d,"dd/MM, HH:mm")}
export function daysSince(v:string){return Math.max(0,differenceInCalendarDays(new Date(),new Date(v)))}
// O formatador nasce uma vez: construir um Intl a cada chamada custa caro e
// esta função roda por linha de tabela.
const BRL_SEM_CENTAVOS = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 })
export const formatCurrency=(value:number)=>BRL_SEM_CENTAVOS.format(value||0)
